import React, { useState } from "react";
import { Box, Button, Stack, TextField, InputLabel } from "@mui/material";
import { addOrUpdateSpeaker } from "../../Requests/SpeakerService.ts";
import { Speaker } from "../../Models/Speaker.ts";
import AvatarDropzone from "../StyledComponents/AvatarDropzone/AvatarDropzone";
import HtmlEditor from '../HtmlEditorView/HtmlEditor.jsx';


export default function SpeakersAdd(props) {
  const [avatar, setAvatar] = useState()
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [bio, setBio] = useState("")
  const [occupation, setOccupation] = useState("")
  const [sortOrder, setSortOrder] = useState()

  const handlePublish = async () => {
    let object = new Speaker()
    object.firstName = firstName
    object.lastName = lastName
    object.bio = bio
    object.hidden = false
    object.occupation = occupation
    object.sortOrder = sortOrder
    await addOrUpdateSpeaker(object, avatar)
    props.publish()
  }

  return (
    <Box sx={{ p: 3 }}>
      <Box>
        <AvatarDropzone
          title={"Speaker Avatar"}
          callbackFile={(file) => { setAvatar(file) }}
        />

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"First Name"}</InputLabel>
          <TextField
            placeholder="First Name"
            value={firstName}
            onChange={(event) => setFirstName(event.target.value)}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Last Name"}</InputLabel>
          <TextField
            placeholder="Last Name"
            value={lastName}
            onChange={(event) => setLastName(event.target.value)}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Occupation"}</InputLabel>
          <TextField
            placeholder="Occupation"
            value={occupation}
            onChange={(event) => setOccupation(event.target.value)}
          />
        </Stack>

        <Stack spacing={1} marginTop={4}>
          <InputLabel>Bio</InputLabel>
          <HtmlEditor initialValue={bio} onChange={setBio} />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Sort order"}</InputLabel>
          <TextField
            type="number"
            placeholder="Enter speaker position"
            value={sortOrder}
            onChange={(event) => setSortOrder(Number(event.target.value))}
          />
        </Stack>
      </Box>

      <Box
        display="flex"
        justifyContent="right"
        marginTop={4}
      >
        <Button
          variant="contained"
          size="large"
          onClick={() => handlePublish()}
        >
          {"Publish"}
        </Button>
      </Box>
    </Box>
  )
}
